import { IS_SERVER_ENVIRONMENT, createErrorMessage, } from "@aviv-unified-frontend/internal";
import { GLOBAL_STORE_KEY } from "./constants";
export const getGlobalStore = () => {
    if (IS_SERVER_ENVIRONMENT) {
        throw new Error(createErrorMessage({
            cause: "The global store is not accessible on server-like environment",
            solution: "Use `IS_SERVER_ENVIRONMENT` check to handle client-side-specific store logic",
        }));
    }
    const globalStore = window[GLOBAL_STORE_KEY];
    if (!globalStore) {
        throw new Error(createErrorMessage({
            cause: "The global store is not defined",
            solution: "Make sure the global store is properly as a global `window` variable set before its usage",
        }));
    }
    return globalStore;
};
